import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "buttonAlignment", "useBodyPaddings", "children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var ApplicationLayoutBodyBottomBar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    buttonAlignment = _ref.buttonAlignment,
    useBodyPaddings = _ref.useBodyPaddings,
    children = _ref.children,
    remainigProps = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames('ApplicationLayoutBodyBottomBar', buttonAlignment === 'left' && 'justify-content-start', buttonAlignment === 'right' && 'justify-content-end', buttonAlignment !== 'left' && buttonAlignment !== 'right' && 'justify-content-between', useBodyPaddings && 'use-body-padding', className && className);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, remainigProps, {
    className: classes
  }), children);
});
ApplicationLayoutBodyBottomBar.LEFT = 'left';
ApplicationLayoutBodyBottomBar.RIGHT = 'right';
ApplicationLayoutBodyBottomBar.defaultProps = {
  useBodyPaddings: false
};
ApplicationLayoutBodyBottomBar.propTypes = {
  className: PropTypes.string,
  useBodyPaddings: PropTypes.bool,
  buttonAlignment: PropTypes.oneOf([ApplicationLayoutBodyBottomBar.LEFT, ApplicationLayoutBodyBottomBar.RIGHT])
};
export default ApplicationLayoutBodyBottomBar;